import React from 'react';
import { Link } from 'react-router-dom';
import BrandLink from './BrandLink';
import { ADDRESS, LINKS, getMapsLink } from '../constants';

const FooterCopy = () => (
  <>
    <p>
      © {new Date().getFullYear()} — Barista Bot is a product of{' '}
      <BrandLink href={LINKS.espressoPlusMilk} className="footer-brand-link">
        Espresso + Milk, LLC
      </BrandLink>
    </p>
    <p>
      <BrandLink href={LINKS.brandMenuOps} className="footer-brand-link">
        Menu-Ops
      </BrandLink>
      {' · '}
      <BrandLink href={LINKS.brandAllCaps} className="footer-brand-link">
        ALL CAPS.
      </BrandLink>
    </p>
    <p>
      <a
        href={getMapsLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-address"
      >
        {ADDRESS.street}, {ADDRESS.suite}
        <br />
        {ADDRESS.city}
      </a>
    </p>
    <p>
      <Link to="/faq">FAQs</Link>
      {'  |  '}
      <Link to="/terms-of-use">Terms of Service</Link>
      {'  |  '}
      <Link to="/privacy-policy">Privacy Policy</Link>
      {' | '}
      <a href={LINKS.account} target="_blank" rel="noopener noreferrer">
        Log In
      </a>
      {' | '}
      <a href={LINKS.brandLogin} target="_blank" rel="noopener noreferrer">
        Brand Login
      </a>
    </p>
  </>
);

export default FooterCopy;
